import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { couponService } from "@/services/api/cresivoxServer";

import { iCouponDTO, REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// Fetch coupon list
export const getCouponList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("CouponList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types

  async (arg, { rejectWithValue }) => {
    try {
      const response = await couponService.getAllCoupons();
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            if (data && data.data) {
              return {
                    httpStatusCode,
                    data: data.data,
                    message,
               
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          default:
            return rejectWithValue({
              httpStatusCode,
              message,
            });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);

// Fetch coupon by ID
export const getCouponById = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { couponId: string },
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getCouponById"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types

  async ({ couponId }, { rejectWithValue }) => {
    try {
      const response = await couponService.getCouponById({couponId});
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            if (data && data.data) {
              return {
                data: {
                  coupon: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          default:
            return rejectWithValue({
              httpStatusCode,
              message,
            });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);

// Update coupon
export const updateCoupon = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { couponId: string; data: iCouponDTO },
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("updateCoupon"),
    // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({ couponId, data }, { rejectWithValue }) => {
    try {
      const response = await couponService.updateCoupon(couponId, data);
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            if (data && data.data) {
              return {
                data: {
                  coupon: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          default:
            return rejectWithValue({
              httpStatusCode,
              message,
            });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);

// Delete coupon
export const deleteCoupon = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { couponId: string },
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("deleteCoupon"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({ couponId }, { rejectWithValue }) => {
    try {
      const response = await couponService.deleteCoupon(couponId);
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK:
            if (data && data.data) {
              return {
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          default:
            return rejectWithValue({
              httpStatusCode,
              message,
            });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);

// Create new coupon
export const createCoupon = createAsyncThunk<
  iGenericResponse<any | null> | null,
  iCouponDTO,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("createCoupon"),
// @ts-expect-error: This is required to handle type incompatibility in third-party library

  async (payload, { rejectWithValue }) => {
    try {
      const response = await couponService.createCoupon(payload);
      if (response) {
        const { httpStatusCode, data, message } = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED:
            if (data && data.data) {
              return {
                data: {
                  coupon: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          default:
            return rejectWithValue({
              httpStatusCode,
              message,
            });
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);
